module.exports = __webpack_public_path__ + "img/phoneBanner1.96e73714.jpg";